import { useSelectedOrders, useToggleAllOrders } from '@montugroup/circuit-shared/context/table/OrderSelectionContext';
import { Checkbox } from '@montugroup/design-system';

type Props = { orders: { orderId: number }[] };

export default function SelectionHeaderCell({ orders }: Props) {
  const selected = useSelectedOrders();
  const toggleAll = useToggleAllOrders();

  const allIds = orders.map((o) => o.orderId);
  const allSelected = allIds.length > 0 && allIds.every((id) => selected.includes(id));
  const hasAny = allIds.some((id) => selected.includes(id));

  return (
    <Checkbox
      disabled={orders.length === 0}
      checked={allSelected}
      indeterminate={!allSelected && hasAny}
      onChange={() => toggleAll(allIds)}
    />
  );
}
